import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github, ArrowUpRight } from 'lucide-react';
import './Footer.css';

const footerLinks = {
  Company: [
    { label: 'About Us', path: '/about' },
    { label: 'Our Team', path: '/about#team' },
    { label: 'Careers', path: '/contact' },
    { label: 'Blog', path: '/' },
    { label: 'Terms of Service', path: '/terms' },
  ],
  Products: [
    { label: 'RTA Software', path: '/products' },
    { label: 'School Management', path: '/products' },
    { label: 'Hotel Software', path: '/products' },
    { label: 'E-Commerce', path: '/products' },
    { label: 'CRM & ERP', path: '/products' },
  ],
  Solutions: [
    { label: 'Enterprise', path: '/solutions' },
    { label: 'SME', path: '/solutions' },
    { label: 'Education', path: '/solutions' },
    { label: 'Hospitality', path: '/solutions' },
    { label: 'Finance', path: '/solutions' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-glow" />
      <div className="container">
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-mark">S</div>
              <span className="footer-logo-name">SHIVKMS</span>
            </Link>
            <p className="footer-desc">
              Empowering businesses across India with intelligent, scalable software solutions since 1998. Your technology partner for sustainable growth.
            </p>
            <div className="footer-contact-list">
              <a href="tel:+919212552928" className="footer-contact-item">
                <Phone size={14} />
                <span>+91 9212552928</span>
              </a>
              <a href="mailto:contact@shivkms.com" className="footer-contact-item">
                <Mail size={14} />
                <span>contact@shivkms.com</span>
              </a>
              <span className="footer-contact-item">
                <MapPin size={14} />
                <span>1000/67, Trinagar, Delhi – 110035</span>
              </span>
            </div>
            <div className="footer-socials">
              <a href="#" aria-label="LinkedIn" className="social-link"><Linkedin size={16} /></a>
              <a href="#" aria-label="Twitter" className="social-link"><Twitter size={16} /></a>
              <a href="#" aria-label="Github" className="social-link"><Github size={16} /></a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category} className="footer-col">
              <h4 className="footer-col-title">{category}</h4>
              <ul className="footer-link-list">
                {links.map(link => (
                  <li key={link.label}>
                    <Link to={link.path} className="footer-link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © {new Date().getFullYear()} SHIVKMS. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
            <a href="/terms" className="footer-link">Terms of Service</a>
            {/* <a href="#" className="footer-link">Sitemap</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
